var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-card",
        { staticClass: "mb-4" },
        [
          _c(
            "v-card-title",
            [
              _c("v-icon", { staticClass: "mr-2" }, [_vm._v("mdi-upload")]),
              _vm._v(" Upload de Arquivo de Devedores ")
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-alert",
                        {
                          staticClass: "mb-4",
                          attrs: { type: "info", outlined: "" }
                        },
                        [
                          _c("div", { staticClass: "font-weight-bold" }, [
                            _vm._v("Instruções:")
                          ]),
                          _c("ul", { staticClass: "mt-2" }, [
                            _c("li", [
                              _vm._v(
                                " Utilize o modelo baixado na aba anterior "
                              )
                            ]),
                            _c("li", [
                              _vm._v("Preencha todos os campos obrigatórios")
                            ]),
                            _c("li", [
                              _vm._v(
                                " ID TITULO deve ser válido e presente no sistema "
                              )
                            ]),
                            _c("li", [
                              _vm._v(
                                " CPF/CNPJ deve ser válido e único por título "
                              )
                            ]),
                            _c("li", [
                              _vm._v(
                                " PRINCIPAL = 1 em exatamente uma linha por título "
                              )
                            ]),
                            _c("li", [
                              _vm._v(
                                " Endereço, Bairro, Cidade, UF e CEP são obrigatórios "
                              )
                            ]),
                            _c("li", [
                              _vm._v("Nome deve ter até 45 caracteres")
                            ]),
                            _c("li", [
                              _vm._v("CEP deve ter 8 dígitos válidos")
                            ]),
                            _c("li", [
                              _vm._v(
                                " E-mail e Telefone são obrigatórios e devem ter mais de 1 caractere "
                              )
                            ]),
                            _c("li", [
                              _vm._v("Formato aceito: Excel (.xlsx, .xls)")
                            ]),
                            _c("li", [_vm._v("Tamanho máximo: 10MB")])
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "8" } },
                    [
                      _c("v-file-input", {
                        attrs: {
                          accept:
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .xls, .xlsx",
                          label: "Selecione o arquivo Excel",
                          "prepend-icon": "mdi-file-excel",
                          "show-size": "",
                          chips: "",
                          outlined: ""
                        },
                        on: { change: _vm.onArquivoSelecionado },
                        scopedSlots: _vm._u([
                          {
                            key: "selection",
                            fn: function({ text }) {
                              return [
                                _c(
                                  "v-chip",
                                  {
                                    attrs: {
                                      color: "primary",
                                      label: "",
                                      small: ""
                                    }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { left: "", small: "" } },
                                      [_vm._v("mdi-file-excel")]
                                    ),
                                    _vm._v(" " + _vm._s(text) + " ")
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.arquivo,
                          callback: function($$v) {
                            _vm.arquivo = $$v
                          },
                          expression: "arquivo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            block: "",
                            disabled: !_vm.arquivo,
                            loading: _vm.processandoArquivo
                          },
                          on: { click: _vm.processarArquivo }
                        },
                        [
                          _c("v-icon", { staticClass: "mr-2" }, [
                            _vm._v("mdi-cog")
                          ]),
                          _vm._v(" Processar Arquivo ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.dadosProcessados.length > 0
        ? _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c("v-icon", { staticClass: "mr-2" }, [_vm._v("mdi-eye")]),
                  _vm._v(" Pré-visualização dos Dados ")
                ],
                1
              ),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-row",
                    { staticClass: "mb-4" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "3" } },
                        [
                          _c(
                            "v-card",
                            { attrs: { color: "blue", dark: "" } },
                            [
                              _c("v-card-text", [
                                _c("div", { staticClass: "text-h6" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.dadosProcessados.length) +
                                      " "
                                  )
                                ]),
                                _c("div", [_vm._v("Total de Registros")])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "3" } },
                        [
                          _c(
                            "v-card",
                            { attrs: { color: "green", dark: "" } },
                            [
                              _c("v-card-text", [
                                _c("div", { staticClass: "text-h6" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.registrosValidos.length) +
                                      " "
                                  )
                                ]),
                                _c("div", [_vm._v("Registros Válidos")])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "3" } },
                        [
                          _c(
                            "v-card",
                            { attrs: { color: "red", dark: "" } },
                            [
                              _c("v-card-text", [
                                _c("div", { staticClass: "text-h6" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.registrosComErro.length) +
                                      " "
                                  )
                                ]),
                                _c("div", [_vm._v("Com Erros")])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "3" } },
                        [
                          _c(
                            "v-card",
                            { attrs: { color: "orange", dark: "" } },
                            [
                              _c("v-card-text", [
                                _c("div", { staticClass: "text-h6" }, [
                                  _vm._v(
                                    " " + _vm._s(_vm.titulosUnicos.length) + " "
                                  )
                                ]),
                                _c("div", [_vm._v("Títulos Únicos")])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.registrosComErro.length > 0
                    ? _c(
                        "v-row",
                        { staticClass: "mb-4" },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "v-alert",
                                {
                                  staticClass: "mb-0",
                                  attrs: { type: "warning", outlined: "" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _c("v-icon", { staticClass: "mr-2" }, [
                                        _vm._v("mdi-alert-circle")
                                      ]),
                                      _vm._v(
                                        " Existem " +
                                          _vm._s(_vm.registrosComErro.length) +
                                          " registro(s) com erro(s) "
                                      )
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "mt-2" }, [
                                    _vm._v(
                                      " Corrija todos os erros antes de pré-visualizar as alterações. Use o relatório de erros para identificar e corrigir os problemas. "
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.opcoesStatus,
                              label: "Filtrar por status",
                              outlined: "",
                              dense: "",
                              clearable: ""
                            },
                            model: {
                              value: _vm.filtroStatus,
                              callback: function($$v) {
                                _vm.filtroStatus = $$v
                              },
                              expression: "filtroStatus"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Filtrar por título",
                              outlined: "",
                              dense: "",
                              clearable: "",
                              "prepend-inner-icon": "mdi-magnify"
                            },
                            model: {
                              value: _vm.filtroTitulo,
                              callback: function($$v) {
                                _vm.filtroTitulo = $$v
                              },
                              expression: "filtroTitulo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("v-data-table", {
                    staticClass: "elevation-1",
                    attrs: {
                      headers: _vm.headersPreVisualizacao,
                      items: _vm.dadosFiltrados,
                      loading: _vm.processandoArquivo,
                      "item-key": "index",
                      "footer-props": {
                        itemsPerPageOptions: [10, 25, 50, 100],
                        itemsPerPageText: "Itens por página:"
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: `item.status`,
                          fn: function({ item }) {
                            return [
                              _c(
                                "v-chip",
                                {
                                  attrs: {
                                    color: item.valido ? "success" : "error",
                                    "text-color": "white",
                                    small: ""
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(item.valido ? "Válido" : "Erro") +
                                      " "
                                  )
                                ]
                              )
                            ]
                          }
                        },
                        {
                          key: `item.erros`,
                          fn: function({ item }) {
                            return [
                              !item.valido
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { bottom: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function({ on, attrs }) {
                                                  return [
                                                    _c(
                                                      "v-icon",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            attrs: {
                                                              color: "error"
                                                            }
                                                          },
                                                          "v-icon",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _vm._v(
                                                          " mdi-alert-circle "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _c(
                                            "div",
                                            _vm._l(item.erros, function(erro) {
                                              return _c("div", { key: erro }, [
                                                _vm._v(
                                                  " • " + _vm._s(erro) + " "
                                                )
                                              ])
                                            }),
                                            0
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          }
                        },
                        {
                          key: `item.documento`,
                          fn: function({ item }) {
                            return [
                              _c(
                                "span",
                                { class: { "text--disabled": !item.valido } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.formatarDocumento(item.documento)
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          }
                        },
                        {
                          key: `item.tipoFormatado`,
                          fn: function({ item }) {
                            return [
                              _c(
                                "v-chip",
                                {
                                  attrs: {
                                    color:
                                      item.principal === 1
                                        ? "primary"
                                        : "secondary",
                                    "text-color": "white",
                                    small: ""
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        item.principal === 1
                                          ? "Principal"
                                          : "Codevedor"
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          }
                        },
                        {
                          key: `item.informacoes`,
                          fn: function({ item }) {
                            return [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "", "max-width": "400" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function({ on, attrs }) {
                                          return [
                                            _c(
                                              "v-icon",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    attrs: { color: "primary" }
                                                  },
                                                  "v-icon",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [_vm._v(" mdi-eye ")]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _c("div", [
                                    _c("div", [
                                      _c("strong", [_vm._v("Endereço:")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(item.endereco || "N/A") +
                                          " "
                                      )
                                    ]),
                                    _c("div", [
                                      _c("strong", [_vm._v("Bairro:")]),
                                      _vm._v(
                                        " " + _vm._s(item.bairro || "N/A") + " "
                                      )
                                    ]),
                                    _c("div", [
                                      _c("strong", [_vm._v("Cidade:")]),
                                      _vm._v(
                                        " " + _vm._s(item.cidade || "N/A") + " "
                                      )
                                    ]),
                                    _c("div", [
                                      _c("strong", [_vm._v("UF:")]),
                                      _vm._v(
                                        " " + _vm._s(item.uf || "N/A") + " "
                                      )
                                    ]),
                                    _c("div", [
                                      _c("strong", [_vm._v("CEP:")]),
                                      _vm._v(
                                        " " + _vm._s(item.cep || "N/A") + " "
                                      )
                                    ]),
                                    _c("div", [
                                      _c("strong", [_vm._v("Email:")]),
                                      _vm._v(
                                        " " + _vm._s(item.email || "N/A") + " "
                                      )
                                    ])
                                  ])
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  }),
                  _c(
                    "v-row",
                    { staticClass: "mt-4" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "primary",
                                disabled: !_vm.podePrevisualizar,
                                loading: _vm.processandoArquivo
                              },
                              on: { click: _vm.abrirModalPreVisualizacao }
                            },
                            [
                              _c("v-icon", { staticClass: "mr-2" }, [
                                _vm._v("mdi-eye")
                              ]),
                              _vm._v(
                                " Pré-visualizar Alterações (" +
                                  _vm._s(_vm.registrosValidos.length) +
                                  " registros) "
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "ml-2",
                              attrs: { color: "secondary" },
                              on: { click: _vm.limparDados }
                            },
                            [
                              _c("v-icon", { staticClass: "mr-2" }, [
                                _vm._v("mdi-refresh")
                              ]),
                              _vm._v(" Limpar ")
                            ],
                            1
                          ),
                          _vm.registrosComErro.length > 0
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "ml-2",
                                  attrs: { color: "warning" },
                                  on: { click: _vm.baixarRelatorioErros }
                                },
                                [
                                  _c("v-icon", { staticClass: "mr-2" }, [
                                    _vm._v("mdi-download")
                                  ]),
                                  _vm._v(" Baixar Relatório de Erros ")
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "1400px", persistent: "", scrollable: "" },
          model: {
            value: _vm.modalPreVisualizacao,
            callback: function($$v) {
              _vm.modalPreVisualizacao = $$v
            },
            expression: "modalPreVisualizacao"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { flat: "", dark: "", color: "primary" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: { click: _vm.fecharModalPreVisualizacao }
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                  _c("v-toolbar-title", [_vm._v("Confirmar Alterações")])
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "pa-4" },
                [
                  _c(
                    "v-alert",
                    {
                      staticClass: "mb-4",
                      attrs: { type: "info", outlined: "" }
                    },
                    [
                      _c("div", { staticClass: "font-weight-bold" }, [
                        _vm._v(" Resumo das Alterações: ")
                      ]),
                      _c("div", { staticClass: "mt-2" }, [
                        _vm._v(
                          " • " +
                            _vm._s(_vm.registrosValidos.length) +
                            " devedores/coodevedores serão processados • " +
                            _vm._s(_vm.titulosUnicos.length) +
                            " título(s) será(ão) atualizado(s) • " +
                            _vm._s(_vm.registrosParaCriar.length) +
                            " novo(s) devedor(es) será(ão) criado(s) • " +
                            _vm._s(_vm.registrosParaAtualizar.length) +
                            " devedor(es) será(ão) atualizado(s) "
                        )
                      ])
                    ]
                  ),
                  _c("v-data-table", {
                    staticClass: "elevation-1",
                    attrs: {
                      headers: _vm.headersModalPreVisualizacao,
                      items: _vm.registrosValidos,
                      "item-key": "index",
                      "footer-props": {
                        itemsPerPageOptions: [10, 25, 50],
                        itemsPerPageText: "Itens por página:"
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: `item.acao`,
                          fn: function({ item }) {
                            return [
                              _c(
                                "v-chip",
                                {
                                  attrs: {
                                    color: _vm.getCorAcao(item.acao),
                                    "text-color": "white",
                                    small: ""
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.formatarAcao(item.acao)) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          }
                        },
                        {
                          key: `item.documento`,
                          fn: function({ item }) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.formatarDocumento(item.documento)
                                  ) +
                                  " "
                              )
                            ]
                          }
                        },
                        {
                          key: `item.tipoFormatado`,
                          fn: function({ item }) {
                            return [
                              _c(
                                "v-chip",
                                {
                                  attrs: {
                                    color:
                                      item.principal === 1
                                        ? "primary"
                                        : "secondary",
                                    "text-color": "white",
                                    small: ""
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        item.principal === 1
                                          ? "Principal"
                                          : "Codevedor"
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          }
                        },
                        {
                          key: `item.informacoes`,
                          fn: function({ item }) {
                            return [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "", "max-width": "400" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function({ on, attrs }) {
                                          return [
                                            _c(
                                              "v-icon",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    attrs: { color: "primary" }
                                                  },
                                                  "v-icon",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [_vm._v(" mdi-eye ")]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _c("div", [
                                    _c("div", [
                                      _c("strong", [_vm._v("Endereço:")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(item.endereco || "N/A") +
                                          " "
                                      )
                                    ]),
                                    _c("div", [
                                      _c("strong", [_vm._v("Bairro:")]),
                                      _vm._v(
                                        " " + _vm._s(item.bairro || "N/A") + " "
                                      )
                                    ]),
                                    _c("div", [
                                      _c("strong", [_vm._v("Cidade:")]),
                                      _vm._v(
                                        " " + _vm._s(item.cidade || "N/A") + " "
                                      )
                                    ]),
                                    _c("div", [
                                      _c("strong", [_vm._v("UF:")]),
                                      _vm._v(
                                        " " + _vm._s(item.uf || "N/A") + " "
                                      )
                                    ]),
                                    _c("div", [
                                      _c("strong", [_vm._v("CEP:")]),
                                      _vm._v(
                                        " " + _vm._s(item.cep || "N/A") + " "
                                      )
                                    ]),
                                    _c("div", [
                                      _c("strong", [_vm._v("Email:")]),
                                      _vm._v(
                                        " " + _vm._s(item.email || "N/A") + " "
                                      )
                                    ])
                                  ])
                                ]
                              )
                            ]
                          }
                        },
                        {
                          key: `item.observacoes`,
                          fn: function({ item }) {
                            return [
                              item.observacoes
                                ? _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function({ on, attrs }) {
                                              return [
                                                _c(
                                                  "span",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass:
                                                          "text-truncate",
                                                        staticStyle: {
                                                          "max-width": "180px",
                                                          display:
                                                            "inline-block"
                                                        }
                                                      },
                                                      "span",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          item.observacoes
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(item.observacoes))
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "pa-4" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "grey", text: "" },
                      on: { click: _vm.fecharModalPreVisualizacao }
                    },
                    [_vm._v(" Cancelar ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "success", loading: _vm.salvandoDados },
                      on: { click: _vm.salvarAlteracoes }
                    },
                    [
                      _c("v-icon", { staticClass: "mr-2" }, [
                        _vm._v("mdi-check")
                      ]),
                      _vm._v(" Salvar Alterações ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }